import { useEffect, useRef } from "react";
import { useAuth } from "@/hooks/useAuth";
import { toast } from "sonner";

const PERM_ASKED = "empire-notif-asked";
const LAST_MORNING = "empire-notif-last-morning";

export function DailyCheckinNotifier() {
  const { user, hasAccess } = useAuth();
  const askedRef = useRef(false);

  useEffect(() => {
    if (!user || !hasAccess) return;
    if (!("Notification" in window)) return;

    // Ask once, after a short delay so it's not intrusive
    if (Notification.permission === "default" && !localStorage.getItem(PERM_ASKED) && !askedRef.current) {
      askedRef.current = true;
      const t = setTimeout(() => {
        toast("Enable daily check-in reminders?", {
          duration: 12000,
          action: {
            label: "Enable",
            onClick: async () => {
              localStorage.setItem(PERM_ASKED, "1");
              await Notification.requestPermission();
            },
          },
          onDismiss: () => localStorage.setItem(PERM_ASKED, "1"),
        });
      }, 30000);
      return () => clearTimeout(t);
    }
  }, [user, hasAccess]);

  // Morning reminder — once per day, when app opens between 5am-11am
  useEffect(() => {
    if (!user || !hasAccess) return;
    const check = () => {
      const now = new Date();
      const hour = now.getHours();
      const today = now.toISOString().slice(0, 10);
      if (localStorage.getItem(LAST_MORNING) === today) return;
      if (hour < 5 || hour > 11) return;
      localStorage.setItem(LAST_MORNING, today);
      if (Notification.permission === "granted") {
        try {
          new Notification("👑 Empire OS", { body: "Time to plan today's empire. Lock in your top 3." });
        } catch {/* ignore */}
      } else {
        toast("☀️ Good morning — plan today's empire", { duration: 6000 });
      }
    };
    check();
    const id = setInterval(check, 15 * 60 * 1000);
    return () => clearInterval(id);
  }, [user, hasAccess]);

  return null;
}
